import { useEffect, useState } from "react";
import Watch from "./watch";
import { useWatches } from "../../../context/watchProvider";
import LoadingBalls from "../../core/loadingBalls";
import { useAuth } from "../../../context/authProvider";
import Filters from "./filters";
import FilterIcon from "../../../img/svg/filterIcon";
import { DocumentData, QueryDocumentSnapshot, WhereFilterOp } from "firebase/firestore";
import { useSearchParams } from "react-router-dom";

export default function Watches({ isMobile }: { isMobile: boolean }) {

    const { searchWatches, cartUpdated, getCartItems, cart, top10, getBrands, getTop10Watches } = useWatches();
    const { userId } = useAuth();
    const [searchParams] = useSearchParams();

    const [watches, setWatches] = useState<{ [key: string]: any; id: string; }[] | [] | null>([]);
    const [total, setTotal] = useState(0);
    const [last, setLast] = useState<QueryDocumentSnapshot<DocumentData, DocumentData>>();
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [query, setQuery] = useState<{ filters: any, price: any, year: any }>({ filters: [], year: null, price: null });

    const [brands, setBrands] = useState<{ brand: string; count: number; }[]>([]);
    const [selectedBrand, setSelectedBrand] = useState("");
    const [loadingBrands, setLoadingBrands] = useState(false);

    useEffect(() => {
        if (searchParams.get("q")) {
            doSearchWatchesFromParams(searchParams.get("q") || "");
        } else {
            doSearchWatches();
            getTop10Watches();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!cartUpdated && userId) {
            getCartItems(userId);
        }
        // eslint-disable-next-line
    }, [cartUpdated]);

    useEffect(() => {
        setModal(false);
    }, [watches])

    useEffect(() => {
        if (modal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [modal]);

    useEffect(() => {
        doGetBrands();
        // eslint-disable-next-line
    }, [top10]);

    const doGetBrands = async () => {
        setLoadingBrands(true);
        const foundBrands = await getBrands();
        if (foundBrands) {
            setBrands(foundBrands);
        }
        setLoadingBrands(false);
    }

    const doSearchWatches = async () => {
        setLoading(true);
        const foundWatches = await searchWatches([]);
        if (foundWatches?.data) {
            setWatches(foundWatches.data);
            setTotal(foundWatches.total);
            setLast(foundWatches.last);
        }
        setLoading(false);
    }
    const doSearchWatchesFromParams = async (q: string) => {
        setLoading(true);
        const filters: { field: string, operator: WhereFilterOp, value: string | string[] | number }[] = [{ field: "searchTerms", operator: "array-contains", value: q.toLowerCase() }];
        const foundWatches = await searchWatches(filters);
        if (foundWatches?.data) {
            setWatches(foundWatches?.data);
            setTotal(foundWatches?.total);
            setLast(foundWatches?.last);
            setQuery({ filters, price: null, year: null });
        }
        setLoading(false);
        setLoading(false);
    }

    const loadMore = async () => {
        if (!watches) {
            return null;
        }
        setLoadingMore(true);
        const foundWatches = await searchWatches(query.filters, query.price, query.year, last);
        if (foundWatches?.data) {
            setWatches([...watches, ...foundWatches.data]);
            setTotal(foundWatches.total);
            setLast(foundWatches.last);
        }
        setLoadingMore(false);
    }

    const handleSelectBrand = async (brand: string) => {
        if (selectedBrand === brand) {
            setSelectedBrand("");
            setQuery({ filters: [], price: null, year: null });
            doSearchWatches();
            return null;
        }
        setLoading(true);
        setSelectedBrand(brand);
        const filters: { field: string, operator: WhereFilterOp, value: string | string[] | number }[] = [{ field: "searchTerms", operator: "array-contains", value: brand.toLowerCase() }];
        const foundWatches = await searchWatches(filters);
        setWatches(foundWatches?.data || null);
        setTotal(foundWatches?.total || 0);
        setLast(foundWatches?.last);
        setQuery({ filters, price: null, year: null })
        setLoading(false);
    }

    return (
        <main className="max-w-7xl mx-auto flex flex-col md:flex-row px-4 md:px-10 py-24 mb-16 gap-10 items-start">
            {
                isMobile ?
                    <div onClick={() => setModal(true)} className="w-full flex justify-center mb-6">
                        <div className="px-6 py-3 bg-primary text-white rounded-full flex items-center gap-4 cursor-pointer shadow-lg active:scale-95 transition-all">
                            <p className="font-bold tracking-widest text-xs">REFINAR BUSCA</p>
                            <FilterIcon fill="#C5A059" />
                        </div>
                    </div>
                    :
                    <div className="w-full md:w-[300px] top-24">
                        <Filters loading={loading} setLoading={setLoading} setSelectedBrand={setSelectedBrand} setWatches={setWatches} setLast={setLast} setTotal={setTotal} setQuery={setQuery} />
                    </div>
            }
            <div className="flex-1 w-full">
                <div className="grid grid-cols-1 gap-6" style={{ display: loading || !watches?.length ? "block" : "grid" }}>
                    {
                        (!query.filters?.length && !query.price && !query.year) || selectedBrand ?
                            <div className="flex gap-2 flex-wrap md:justify-start justify-center">
                                {
                                    loadingBrands ?
                                        <div className="flex justify-center py-20"><LoadingBalls /></div>
                                        :

                                        brands.map((b, i) => (
                                            <button
                                                key={i}
                                                onClick={() => handleSelectBrand(b.brand)}
                                                className={`px-8 py-3 rounded-full text-xs font-black tracking-widest transition-all duration-300 border-2 ${b.brand === selectedBrand
                                                    ? "bg-primary border-primary text-secondary shadow-lg shadow-primary/20 scale-105"
                                                    : "bg-white border-primary/5 text-mono hover:border-secondary hover:text-secondary"
                                                    }`}
                                            >
                                                {b.brand.toUpperCase()}
                                            </button>
                                        ))

                                }
                            </div>
                            : null
                    }
                    {
                        loading ?
                            <div className="flex justify-center py-20"><LoadingBalls /></div>
                            :
                            !watches?.length ?
                                <div className="text-center py-20 bg-moninho rounded-3xl border border-dashed border-mono/30 text-mono">
                                    <p className="text-lg uppercase tracking-widest font-bold">Nenhum resultado encontrado</p>
                                    <p className="text-sm">Tente ajustar seus filtros de busca</p>
                                </div>
                                :
                                watches?.map((w, i) => (
                                    <Watch key={i} watch={w} isCart={cart?.includes(w.id)} />
                                ))
                    }
                </div>
                {
                    watches?.length !== total && !query.price && !query.year ?
                        <div className="flex justify-center mt-12">
                            {
                                loadingMore ?
                                    <div className="py-2">
                                        <LoadingBalls />
                                    </div>
                                    :
                                    <button
                                        className="px-10 py-4 bg-white border-2 border-primary text-primary font-black tracking-widest text-xs hover:bg-primary hover:text-white transition-all duration-300 active:scale-95 rounded-full"
                                        disabled={loadingMore}
                                        onClick={loadMore}
                                    >
                                        CARREGAR MAIS PRODUTOS
                                    </button>
                            }

                        </div>
                        : null
                }
            </div>

            {
                modal ?
                    <div className="fixed z-[120] inset-0 bg-primary/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-4">
                        <div onClick={() => setModal(false)} className="absolute inset-0" />
                        <div className="w-full max-w-lg bg-white rounded-3xl shadow-2xl animate-superfade relative overflow-hidden flex flex-col max-h-[85vh]">
                            <div className="flex justify-between items-center p-6 border-b border-surface bg-white sticky top-0 z-10">
                                <h3 className="font-black tracking-widest text-primary uppercase">Filtros Avançados</h3>
                                <button onClick={() => setModal(false)} className="p-2 hover:bg-moninho rounded-full transition-colors font-bold text-mono">✕</button>
                            </div>
                            <div className="overflow-y-auto p-6">
                                <Filters loading={loading} setLoading={setLoading} setSelectedBrand={setSelectedBrand} setWatches={setWatches} setLast={setLast} setTotal={setTotal} setQuery={setQuery} />
                            </div>
                        </div>
                    </div>
                    : null
            }
        </main>
    )
}
